import { useState } from "react";
import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  SelectInput,
  TextField,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { Button, Chip } from "@mui/material";

import { adminApi } from "../../dataProvider";

// Задача менеджеру: клиент пополнил карту рублями — под выданные ему доллары нужно откупить
// USDT по зафиксированному курсу. Клиент этого не видит, у него пополнение мгновенное.
type Conversion = {
  id: string;
  user_phone: string | null;
  user_name: string | null;
  amount_rub: number;
  rate: number;
  amount_usdt: number;
  status: "new" | "done";
  comment: string | null;
  done_at: string | null;
  created_at: string;
};

const filters = [
  <SelectInput
    key="status"
    source="status"
    label="Статус"
    alwaysOn
    choices={[
      { id: "new", name: "Новые" },
      { id: "done", name: "Откуплены" },
    ]}
  />,
];

const DoneButton = () => {
  const record = useRecordContext<Conversion>();
  const notify = useNotify();
  const refresh = useRefresh();
  const [saving, setSaving] = useState(false);
  if (!record || record.status === "done") return null;

  const markDone = async () => {
    setSaving(true);
    try {
      await adminApi(`/admin/card-conversions/${record.id}/done`, { method: "POST", json: {} });
      notify("Отмечено как откупленное", { type: "success" });
      refresh();
    } catch (e) {
      notify(e instanceof Error ? e.message : "Не удалось сохранить", { type: "error" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Button size="small" variant="outlined" disabled={saving} onClick={markDone}>
      {saving ? "Сохранение…" : "Откуплено"}
    </Button>
  );
};

export function CardConversionList() {
  return (
    <List
      filters={filters}
      filterDefaultValues={{ status: "new" }}
      perPage={50}
      sort={{ field: "created_at", order: "DESC" }}
      exporter={false}
    >
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <DateField source="created_at" label="Создана" showTime />
        <FunctionField
          label="Клиент"
          render={(r: Conversion) => r.user_name || r.user_phone || "—"}
        />
        <FunctionField
          label="Сумма, ₽"
          render={(r: Conversion) => Number(r.amount_rub).toLocaleString("ru-RU", { minimumFractionDigits: 2 })}
        />
        <FunctionField label="Курс" render={(r: Conversion) => `${Number(r.rate).toFixed(2)} ₽ за $1`} />
        <FunctionField
          label="Откупить, USDT"
          render={(r: Conversion) => Number(r.amount_usdt).toFixed(2)}
        />
        <FunctionField
          label="Статус"
          render={(r: Conversion) =>
            r.status === "done" ? (
              <Chip size="small" color="success" label="Откуплено" />
            ) : (
              <Chip size="small" color="warning" label="Новая" />
            )
          }
        />
        <TextField source="comment" label="Комментарий" emptyText="—" />
        <FunctionField label="" render={() => <DoneButton />} />
      </Datagrid>
    </List>
  );
}
